import { Redirect, useLocalSearchParams, type Href } from 'expo-router';

export default function TenantSettingsRedirect() {
  const { tenant } = useLocalSearchParams<{ tenant: string }>();

  return <Redirect href={`/admin/${tenant}/settings/integrations` as Href} />;
}
